import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-company-edit-modal',
  templateUrl: './company-edit-modal.component.html',
  styleUrls: ['./company-edit-modal.component.css']
})
export class CompanyEditModalComponent implements OnInit {
  @Input() company: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveCompany(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
